/**
 * The version shown on the title and the change list it opens (spec 08 §5, as NIGHTDROP). The two
 * are held together by a test: every release raises package.json's version and adds its entry to
 * CHANGELOG.md.
 */

import pkg from '../../package.json';
import changelog from '../../CHANGELOG.md?raw';

export const VERSION: string = pkg.version;

/** One release in the change list: its version, date and the player-facing lines. */
export interface Release {
  version: string;
  date: string;
  lines: readonly string[];
}

/** CHANGELOG.md's `## x.y.z - date` sections and their `- ` lines, newest first. */
export function parseChangelog(text: string): Release[] {
  const out: Release[] = [];
  for (const line of text.split(/\r?\n/)) {
    const head = /^## (\d+\.\d+\.\d+) - (\d{4}-\d{2}-\d{2})\s*$/.exec(line);
    if (head?.[1] && head[2]) out.push({ version: head[1], date: head[2], lines: [] });
    else if (line.startsWith('- ')) (out.at(-1)?.lines as string[] | undefined)?.push(line.slice(2).trim());
  }
  return out;
}

export const RELEASES: readonly Release[] = parseChangelog(changelog);
